'use client'

import { CopyButton } from '@/components/ui/copy-button'
import { cn } from '@/lib/utils'

export type AskFare = 'free' | 'quoted' | 'both'

export interface HomeAsk {
  prompt: string
  reads: string
  fare: AskFare
}

const FARE_LABEL: Record<AskFare, string> = {
  free: 'Free',
  quoted: 'Quoted first',
  both: 'Free + quoted',
}

export function AskList({ asks }: { asks: readonly HomeAsk[] }) {
  return (
    <ul className="divide-y divide-[#2E113D]/10 border-y border-[#2E113D]/10">
      {asks.map(ask => (
        <li
          key={ask.prompt}
          className="grid gap-3 py-5 sm:grid-cols-[minmax(0,1fr)_11rem_auto] sm:items-center sm:gap-6"
        >
          <div className="min-w-0">
            <p className="text-lg leading-snug text-[#1F0F2B] sm:text-xl">{ask.prompt}</p>
            <p className="mt-1.5 text-sm text-[#2E113D]/60">Reads {ask.reads}</p>
          </div>
          <span
            className={cn(
              'inline-flex w-fit items-center rounded-full px-3 py-1 font-mono text-xs',
              ask.fare === 'free' && 'bg-[#E9DFFE] text-[#2E113D]',
              ask.fare === 'quoted' && 'bg-[#FEF405] text-[#2E113D]',
              ask.fare === 'both' && 'bg-[linear-gradient(90deg,#E9DFFE_50%,#FEF405_50%)] text-[#2E113D]',
            )}
          >
            {FARE_LABEL[ask.fare]}
          </span>
          <CopyButton
            value={ask.prompt}
            aria-label={`Copy prompt: ${ask.prompt}`}
            showText
            size="sm"
            variant="outline"
            text="Copy"
            successText="Copied"
            successMessage="Prompt copied. Paste it into your AI app."
            className="w-fit rounded-full border-[#2E113D]/20 text-[#2E113D] hover:bg-[#2E113D] hover:text-white"
          />
        </li>
      ))}
    </ul>
  )
}
